<template>
  <ui-dialog
    :isLoading="isLoading"
    :title="L10n('closing')"
    :isVisible="true"
    @close="_closeDialog"
  >
    <form-editor
      :model="model"
      :showPoOpen="showPoOpen"
      :data="data"
      ref="form"
    />
    <template v-slot:footer>
      <div class="activity-po-wo-wrap__footer">
        <button class="btn btn-border grey btn-size-s btn-mobile-full" @click="_closeDialog">
          {{L10n('close')}}
        </button>
        <button class="ml-sm-3 btn btn-border blue btn-size-s btn-mobile-full" @click="_onConfirmWithoutPoClosing">
          {{L10n('confirm-without-po-closing')}}
        </button>
        <button class="ml-sm-3 btn btn-border blue btn-size-s btn-mobile-full" @click="_onSubmit">
          {{L10n('finish-closing')}}
        </button>
      </div>
    </template>
  </ui-dialog>
</template>

<script>

export default {
  name: 'DialogOrderPhase',
  components: {
    'ui-dialog': () => import(/* webpackChunkName: 'Shared' */ '@/components/Dialogs/Dialog'),
    'form-editor': () => import(/* webpackChunkName: 'Shared' */ './FormOrderPhase')
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    salesOrderIDList: {
      required: true,
      type: Array
    },
    showPoOpen: {
      type: Boolean,
      required: true
    }
  },
  created () {
    this._resetForm()
  },
  data () {
    return {
      data: {}
    }
  },
  methods: {
    model () {
      return {
        scoreID: null,
        poStillOpen: this.showPoOpen ? false : undefined
      }
    },
    _resetForm () {
      this.data = {}
    },
    _closeDialog () {
      this.$emit('onClose')
      this._resetForm()
    },
    async _onConfirmWithoutPoClosing () {
      this.$emit('onSuccessWithoutClosing')
      this._resetForm()
    },
    async _onSubmit () {
      const form = this.$refs.form
      return form
        .validate()
        .then(() => {
          this.$emit('onSuccess', form.getData())
          this._resetForm()
        })
    }
  }
}
</script>
